import { Card, CardContent } from '../ui/card';
import { MessageSquare, Handshake, Gavel } from 'lucide-react';

const steps = [
  { icon: MessageSquare, title: "Share Your Side", desc: "Party A explains their perspective on the dispute clearly and honestly." },
  { icon: Handshake, title: "Invite Your Partner", desc: "Send a private invite link so Party B can share their side independently." },
  { icon: Gavel, title: "Receive the Verdict", desc: "Our AI analyses both sides and delivers a fair, balanced resolution with actionable steps." },
];

export const HowItWorksSection = () => (
  <section className="py-20 sm:py-28 bg-muted/30" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <span className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-primary">How It Works</span>
        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif font-bold">
          Three Steps to Resolution
        </h2>
        <p className="mt-3 text-muted-foreground text-base max-w-lg mx-auto">
          No more circular arguments. Get a fair, AI-powered resolution in minutes.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step, i) => (
          <Card key={step.title} className="card-hover border rounded-2xl bg-card shadow-sm" data-testid={`step-card-${i}`}>
            <CardContent className="p-8">
              <div className="h-12 w-12 rounded-2xl bg-primary/10 flex items-center justify-center mb-5">
                <step.icon className="h-6 w-6 text-primary" />
              </div>
              <div className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-muted-foreground mb-2">
                Step {i + 1}
              </div>
              <h3 className="text-xl font-serif font-bold mb-2">{step.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{step.desc}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
